import React from 'react';
import { A } from 'hookrouter';
import { bookingStatusOptions, courseCategoryOptions, courseLanguageOptions, courseStatusOptions, getOptionsObjectValue, translateOptionValue } from '../exl/shared/translations';
import { findBookingByEmpId, getEmployeeCourseRole } from './EmployeeCourseInfoHelperFunctions';
import OnHoverTooltip from '../tables/shared/OnHoverTooltip';
import moment from 'moment';
import Loading from '../Loading';
import FilterCell from '../exl/EmployeeCourseFilterCell';
import BookingStatusDisplay from './BookingStatusDisplay';
import { useTranslation } from 'react-i18next';
import { COURSE_TABLE_NAME_COL, COURSE_BOOKINGS_STATUS_LABEL, GENERAL_COURSE_INFO_STATUS_LABEL, GENERAL_COURSE_INFO_CATEGORY_LABEL, GENERAL_COURSE_INFO_LANGUAGE_LABEL, LECTURE_DETAILS_BODY_ATTENDANCE_LABEL, COURSE_TABLE_START_DATE_COL, COURSE_TABLE_END_DATE_COL, EMP_TABLE_ROLE_COL, NO, YES, COURSE_TABLE_NO_START_DATE, COURSE_TABLE_NO_END_DATE, EMPLOYEE_DETAILS_COURSE_STATUS_DESC, EMPLOYEE_DETAILS_COURSE_ROLE_DESC, EMPLOYEE_DETAILS_NO_COURSES_INFO } from '../../i18n/keyConstants';

const EmpCourseInfo = ({ courses, id, isLoading }) => {
    id = decodeURIComponent(id);
    const { t } = useTranslation();

    function getEmployeeAttendance(course, id) {
        const scheduledCourse = courseStatusOptions.Scheduled.value;
        const cancelledCourse = courseStatusOptions.Cancelled.value;

        const finishedBooking = bookingStatusOptions.Finished.value;
        const certifiedBooking = bookingStatusOptions.Certified.value;
        const traineeCertifiedBooking = bookingStatusOptions.TraineeCertified.value;
        const absentBooking = bookingStatusOptions.Absent.value;
        const cancelledBooking = bookingStatusOptions.Cancelled.value;

        var courseStatus = translateOptionValue(course.status, courseStatusOptions);
        if (courseStatus !== scheduledCourse && courseStatus !== cancelledCourse) {
            var currentBooking = course.bookings.find(b => b.coaEmpId.toLowerCase() === id.toLowerCase());
            var bookingStatus = currentBooking?.status;
            if (currentBooking && course.hasReportedAttendance && bookingStatus !== cancelledBooking) {
                if (bookingStatus === certifiedBooking || bookingStatus === traineeCertifiedBooking || bookingStatus === finishedBooking) {
                    return t(YES);
                } else if (bookingStatus === absentBooking) {
                    return t(NO);
                } else {
                    return `${currentBooking.attendances.length} / ${course.lectures.length}`;
                }
            }
        }
        return "-";
    }

return (
    <>
        {isLoading ? <Loading></Loading> :
            courses && courses.length ? (
                <section>
                    <div className='container'>
                        <div style={{ display: 'flex', width: '300px' }}>
                            <FilterCell column={{ name: "status" }} id={id} ></FilterCell>
                            <OnHoverTooltip
                                labelClassNames='d-flex margin-none'
                                tooltipType='dark'
                                tooltipPlace='right'
                                tooltipEffect='solid'>
                                <span className='oi oi-info c-steelblue padding-left-20px' style={{ fontSize: "10px", paddingTop: "12px" }} />
                                {t(EMPLOYEE_DETAILS_COURSE_STATUS_DESC, { ns: 'employeeDetails' })}
                            </OnHoverTooltip>
                            <FilterCell column={{ name: "role" }} id={id} ></FilterCell>
                            <OnHoverTooltip
                                labelClassNames='d-flex margin-none'
                                tooltipType='dark'
                                tooltipPlace='right'
                                tooltipEffect='solid'>
                                <span className='oi oi-info c-steelblue padding-left-10px' style={{ fontSize: "10px", paddingTop: "12px" }} />
                                {t(EMPLOYEE_DETAILS_COURSE_ROLE_DESC, { ns: 'employeeDetails' })}
                            </OnHoverTooltip>
                        </div>
                        <div>
                            <div className='d-flex justify-content-between col-12 employee-courses padding-none'>
                                <table className='table table-striped table-sm font'>
                                    <thead>
                                        <tr>
                                            <th className='padding-left-10px'>{t(COURSE_TABLE_NAME_COL, { ns: 'courseTable' })}</th>
                                            <th className='text-center'>{t(GENERAL_COURSE_INFO_STATUS_LABEL, { ns: 'generalCourseInformation' })}</th>
                                            <th className='text-center'>{t(COURSE_BOOKINGS_STATUS_LABEL, { ns: 'courseBookings' })}</th>
                                            <th className='text-center'>{t(GENERAL_COURSE_INFO_CATEGORY_LABEL, { ns: 'generalCourseInformation' })}</th>
                                            <th className='text-center'>{t(GENERAL_COURSE_INFO_LANGUAGE_LABEL, { ns: 'generalCourseInformation' })}</th>
                                            <th className='text-center'>{t(LECTURE_DETAILS_BODY_ATTENDANCE_LABEL, { ns: 'lectureDetailsBody' })}</th>
                                            <th className='text-center'>{t(EMP_TABLE_ROLE_COL, { ns: 'employeeTable' })} </th>
                                            <th className='text-right padding-left-10px'>{t(COURSE_TABLE_START_DATE_COL, { ns: 'courseTable' })}</th>
                                            <th className='text-right padding-right-10px'>{t(COURSE_TABLE_END_DATE_COL, { ns: 'courseTable' })}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {courses.map((course, index) => (
                                            <tr key={index}>
                                                {course.isRemoved === false && (
                                                    <>
                                                        <td className='padding-left-10px month'>
                                                            <A href={`/exlCourseDetails/${course.id}`}>{course.name}</A>
                                                        </td>

                                                        <td className='text-center'>
                                                            {t(translateOptionValue(course.status, courseStatusOptions), { ns: 'shared' })}
                                                        </td>
                                                        <td className='text-center'>
                                                            <BookingStatusDisplay booking={findBookingByEmpId(course, id, t)} />
                                                        </td>
                                                        <td className='text-center'>
                                                            {t(translateOptionValue(course.category, courseCategoryOptions), { ns: 'shared' })}
                                                        </td>
                                                        <td className='text-center'>
                                                            {t(translateOptionValue(course.language, courseLanguageOptions), { ns: 'shared' })}
                                                        </td>
                                                        <td className='text-center'>
                                                            {getEmployeeAttendance(course, id)}
                                                        </td>
                                                        <td className='text-center'>
                                                            {getEmployeeCourseRole(course, id, t)}
                                                        </td>
                                                        <td className='text-right intern-hours'>{moment.utc(course.startDate).local().isValid() ? moment.utc(course.startDate).local().format('YYYY-MM-DD') : t(COURSE_TABLE_NO_START_DATE, { ns: 'courseTable' })}</td>
                                                        <td className='text-right intern-hours padding-right-10px'>{moment.utc(course.endDate).local().isValid() ? moment.utc(course.endDate).local().format('YYYY-MM-DD') : t(COURSE_TABLE_NO_END_DATE, { ns: 'courseTable' })}</td>
                                                    </>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <>
                    <div className='container'>
                        <div style={{ display: 'flex', width: '150px' }}>
                            <FilterCell column={{ name: "status" }} id={id}></FilterCell>
                            <OnHoverTooltip
                                labelClassNames='d-flex margin-none'
                                tooltipType='dark'
                                tooltipPlace='right'
                                tooltipEffect='solid'>
                                <span className='oi oi-info c-steelblue padding-left-20px' style={{ fontSize: "10px", paddingTop: "12px" }} />
                                {t(EMPLOYEE_DETAILS_COURSE_STATUS_DESC, { ns: 'employeeDetails' })}
                            </OnHoverTooltip>
                            <FilterCell column={{ name: "role" }} id={id}></FilterCell>
                            <OnHoverTooltip
                                labelClassNames='d-flex margin-none'
                                tooltipType='dark'
                                tooltipPlace='right'
                                tooltipEffect='solid'>
                                <span className='oi oi-info c-steelblue padding-left-10px' style={{ fontSize: "10px", paddingTop: "12px" }} />
                                {t(EMPLOYEE_DETAILS_COURSE_ROLE_DESC, { ns: 'employeeDetails' })}
                            </OnHoverTooltip>
                        </div>
                        <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                            <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_COURSES_INFO, { ns: 'employeeDetails' })}</p>
                        </div>
                    </div>
                </>
            )}
    </>
);
};

export default EmpCourseInfo;
